
import { useNodeActions } from '@/composables/useNodeActions';
import { useNodeUtils } from '@/composables/useNodeUtils';
import NodeAction from '@/components/graph/common/NodeAction.vue';
import NodeWrapper from '@/components/graph/common/NodeWrapper.vue';

export default {
  components: {
    NodeWrapper,
    NodeAction,
  },

  setup() {
    const nodeType = 'start-node';
    const nodeId = 'start-node';
    const nodeAction = { click: true, key: 'custom' };

    const { ampData, uiData, canEditAmp } = useNodeUtils({ nodeType });
    const { onDrop } = useNodeActions();

    const dragHandler = (e, hovered) => {
      e.dataTransfer.dropEffect = 'move';
      uiData.value = { ...uiData.value, hovered };
    };

    const onNodeDrop = (event) => {
      if (!canEditAmp.value) {
        return;
      }

      onDrop(event, nodeId);
    };

    return {
      ampData,
      uiData,
      canEditAmp,
      nodeAction,
      nodeType,
      nodeId,
      dragHandler,
      onNodeDrop,
    };
  },
};
